import React from "react";

function PaymentOutDetails() {
  return <div>PaymentOutDetails</div>;
}

export default PaymentOutDetails;
